// UnCloned® Brand Framework — seven phases. Each phase is an award earned when
// a recipient completes the milestones inside that phase.
// Keep the KEY strings in sync with backend seed.CATEGORY_COLORS.
export const CATEGORY_COLORS = {
    'UnCloned® CEO': '#FC861E',                     // Pumpkin
    'UnCloned® Brand I.D. & I.P.': '#4A0A66',       // Grape
    'UnCloned® Offers': '#DF1283',                  // Berry
    'UnCloned® Marketing & Launches': '#0FFFE2',    // Water (cyan)
    'UnCloned® Content': '#D0FF0D',                 // Lime
    'Opportunity Hour®': '#FC861E',                 // Pumpkin (shares with CEO)
    'UnCloned® Publishing': '#4A0A66',              // Grape (shares with Brand I.D.)
};

export const CATEGORY_MAX_MILESTONES = {
    'UnCloned® CEO': 7,
    'UnCloned® Brand I.D. & I.P.': 6,
    'UnCloned® Offers': 1,
    'UnCloned® Marketing & Launches': 5,
    'UnCloned® Content': 2,
    'Opportunity Hour®': 2,
    'UnCloned® Publishing': 1,
};

export const CATEGORY_LIST = Object.keys(CATEGORY_COLORS);

export function colorForCategory(name) {
    return CATEGORY_COLORS[name] || '#FFFFFF';
}

// Some brand colors (like UN-GRAPE #4A0A66) are too dark to read as text on
// a black background. This returns a bright, on-brand palette color to use for
// TEXT (e.g. milestone stats) — swaps Grape → Berry so we stay strictly inside
// the UnCloned® palette.
export function textAccent(name) {
    const c = CATEGORY_COLORS[name];
    if (!c) return '#FFFFFF';
    if (c === '#4A0A66') return '#DF1283'; // Grape → readable Berry
    return c;
}

// Return contrasting text color (black for light bg, white for dark)
export function textOn(color) {
    if (!color) return '#FFFFFF';
    const c = color.replace('#', '');
    const r = parseInt(c.substring(0, 2), 16);
    const g = parseInt(c.substring(2, 4), 16);
    const b = parseInt(c.substring(4, 6), 16);
    // YIQ
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 140 ? '#000000' : '#FFFFFF';
}

// Convert a phase name into a stable slug for use in data-testids etc.
// e.g. "UnCloned® Brand I.D. & I.P." -> "uncloned-brand-i-d-i-p"
export function categorySlug(name) {
    return String(name || '')
        .toLowerCase()
        .replace(/®/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}
